import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import './BlogList.css'; // Make sure you style this file

const BlogList = () => {
  const [blogs, setBlogs] = useState([]);

  useEffect(() => {
    fetchBlogs();
  }, []);

  const fetchBlogs = async () => {
    const res = await axios.get('/api/blogs');
    setBlogs(res.data);
  };

  return (
    <div>
      <div className="sapfincon-wrapper">
  <div className="background-animation">
    <div className="floating-circle"></div>
    <div className="floating-circle"></div>
    <div className="floating-circle"></div>
    <div className="floating-circle"></div>
    <div className="floating-circle"></div>
    <div className="floating-circle"></div>
  </div>
         <div
  className="jumbotron jumbotron-fluid page-header position-relative overlay-bottom"
  style={{ marginBottom: '90px',width: "120vw", position: "relative",left: "-10vw"}}
>
  <div
    className="container text-center py-5 px-0"
    style={{ marginTop: "-80px" }}
  >
    <h1 className="text-white display-1">Products</h1>
    <div className="d-inline-flex text-white mb-5">
      <p className="m-0 text-uppercase">
        <a className="text-white" href="">Home</a>
      </p>
      <i className="fa fa-angle-double-right pt-1 px-3"></i>
      <p className="m-0 text-uppercase">Products</p>
    </div>

    <div className="w-100 mb-5" style={{ maxWidth: '600px', margin: '0 auto' }}>
  
    </div>
  </div>
</div>
   <div className="blog-grid">
      
      {blogs.map(blog => (
        <div key={blog._id} className="blog-card">
          <img
            src={`/uploads/${blog.imagePath}`}
            alt="blog"
          />
          <h3>{blog.title}</h3>
          <p>{blog.caption}</p>
          <Link
            to="/BlogDetail"
            state={{ id: blog._id }}
            className="read-more-button"
          >
            Read More →
          </Link>
        </div>
      ))}
    </div>
   

    </div></div>
  );
};

export default BlogList;
